import Container from "react-bootstrap/Container";
import ChannelList from "./ChannelList";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { useLocation } from "react-router-dom";

const Channels = ({
  mine,
  page,
  paddingRight = true,
  select = false,
  tab,
  limitedCardNumber,
  searchedText,
}) => {
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const searchQuery = new URLSearchParams(location.search).get("search") || "";

  return (
    <>
      <ContentWrapper>
        <Container
          style={{
            minHeight: "85vh",
            paddingLeft: "30px",
            paddingRight: paddingRight ? "250px" : "30px",
          }}
          fluid
          className="pb-0"
        >
          <ChannelList
            mine={mine}
            select={select}
            searchedText={searchedText ?? searchQuery}
            tab={tab}
            limitedCardNumber={limitedCardNumber}
            campaign={campaignId}
          />
          {/* {!mine && (
            <>
              <hr />
              <FeaturedVideos />
            </>
          )} */}
        </Container>
        {paddingRight && <ThinFooter />}
      </ContentWrapper>
    </>
  );
};

export default Channels;
